import { DownloadAppCard } from "@monsterindia/seeker-jobs";
import dynamic from "next/dynamic";
import React from "react";

import { useDashboardContext } from "..";
import DashboardHeader from "../dashboardHeader";
import { RECOMMENDED } from "../dashboardTabs/constants/dashboardTabs";

const ExternalAd = dynamic(
  () => import("@/components/dashboard/ExternalAd/ExternalAd"),
  {
    ssr: false,
  },
);

const BannerSection = ({}) => {
  const { isMobile, jobServerData } = useDashboardContext();

  const activeTab = jobServerData.activeTab;
  const jobPreferenceData =
    jobServerData.profilePersonalDetails?.jobPreferenceSection;
  return (
    <div className="hidden flex-col gap-8 md:sticky md:!flex md:w-[300px] md:shrink-0 md:grow-0 md:rounded-xl">
      <DashboardHeader
        isMobile={isMobile}
        activeTab={activeTab}
        jobPreferenceData={jobPreferenceData}
        doNotRender={jobServerData.activeTab === RECOMMENDED ? false : true}
      />
      <DownloadAppCard />
      <div className="overflow-hidden rounded-xl">
        <ExternalAd
          adName={
            isMobile
              ? "BB-Mobile-SRP-Cards"
              : "BB-Desktop-Profile-Dashboard-Cards"
          }
          adSize={isMobile ? [320, 50] : [300, 250]}
          isBBSlot={true}
          isLoggedIn={true}
          profilePersonalData={jobServerData.profilePersonalDetails}
        />
      </div>
    </div>
  );
};

export default BannerSection;
